module.exports = __webpack_public_path__ + "static/media/ Dots.36e89b57.svg";